import { useState, useEffect } from 'react';
import { api, apiEndPoints } from '../../../api';
import {
  useNavigate,
  useParams,
  useSearchParams,
  createSearchParams,
  useMatch,
} from 'react-router-dom';
export default function useCreateCustomerModal(data, edit, open) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedBuyers, setSelectedBuyers] = useState([]);
  const [showEditGroupDetails, setShowEditGroupDetails] = useState(false);
  const [buyersData, setBuyersData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [globalSearchValue, setGlobalSearchValue] = useState('');
  const [groupNameValue, setGroupNameValue] = useState('Group Name ##');
  const [groupDescriptionValue, setGroupDescriptionValue] = useState(
    'Your description here'
  );
  const [columnSearchValues, setColumnSearchValues] = useState([]);
  const [salesRep, setSalesRep] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [showBuyers, setShowBuyers] = useState('');
  const [filterString, setFilterString] = useState('');
  const [groups, setGroups] = useState([]);
  //  sort columns
  const [sortColumns, setSortColumns] = useState([]);
  const [sortColumn, setSortColumn] = useState({});

  // zero selected buyers alert modal state
  const [showZeroBuyerError, setShowZeroBuyerError] = useState(false);

  //state to manage loading
  const [isLoading, setIsLoading] = useState(false);

  const [isSelectAll, setIsSelectAll] = useState(false);

  useEffect(() => {
    if (edit) {
      setGroupNameValue(data?.name);
      setGroupDescriptionValue(data?.description);
    } else {
      setGroupNameValue('Group Name ##');
      setGroupDescriptionValue('Your description here');
    }
  }, [open, data]);
  const [showApplyFiltersModal, setShowApplyFiltersModal] = useState(false);
  useEffect(() => {
    getBuyers(page, rowsPerPage, globalSearchValue, data?.id);
  }, [rowsPerPage, page, globalSearchValue, filterString, data]);

  //set selected buyers on initial load
  useEffect(() => {
    const arr = data?.buyer_ids?.split(',');
    if (Array.isArray(arr)) setSelectedBuyers(arr);
  }, [data]);

  const handleSelectAll = (buyersList) => {
    let newBuyerList = [];
    buyersList.forEach((buyer) => {
      if (!selectedBuyers.some((obj) => obj === buyer.id)) {
        newBuyerList.push(buyer.id);
      }
    });
    if (newBuyerList?.length > 0) {
      setSelectedBuyers((prev) => [...prev, ...newBuyerList]);
    }
  };
  async function getBuyers(pageNumber, rowsPerPage, search, groupId) {
    setIsLoading(true);
    if (edit && groupId) {
      const res = await api.get(
        `${
          apiEndPoints.buyerList
        }?page=${pageNumber}&limit=${rowsPerPage}&search=${globalSearchValue}&filters={"groupIds":["${groupId}"]${
          filterString ? ',' : ''
        }${filterString ? filterString : ''}}`
        // `${apiEndPoints.buyerList}?page=${pageNumber}&limit=${limit}&search=${globalSearchValue}&filters=${filterString}&groupIds=["${groupId}"]`
      );

      if (res) {
        setBuyersData(res?.data);
        let sortColumnsValue = [];
        res?.data?.columns.forEach((item) => {
          let obj = {
            columnName: item.accessor,
            sortValue: 'ASC',
          };
          sortColumnsValue.push(obj);
        });
        setSortColumns(sortColumnsValue);
        if (isSelectAll) {
          handleSelectAll(res?.data?.data);
        }
        if (parseInt(res.data.count) == selectedBuyers.length) {
          if (!isSelectAll) setIsSelectAll(true);
        }
      }
    } else {
      const res = await api.get(
        `${apiEndPoints.buyerList}?page=${pageNumber}&limit=${rowsPerPage}&search=${globalSearchValue}&filters=${filterString}`
      );
      if (res) {
        setBuyersData(res?.data);
        let sortColumnsValue = [];
        res?.data?.columns.forEach((item) => {
          let obj = {
            columnName: item.accessor,
            sortValue: 'ASC',
          };
          sortColumnsValue.push(obj);
        });
        setSortColumns(sortColumnsValue);
        if (isSelectAll) {
          handleSelectAll(res?.data?.data);
        }
      }
    }
    setIsLoading(false);
  }

  // sort buyers column
  async function sortBuyersColumns(columnName) {
    setIsLoading(true);
    let sortType = sortColumn?.sortType === 'ASC' ? 'DESC' : 'ASC';
    setSortColumn({
      columnName: columnName,
      sortType: sortType,
    });

    let sortValue = 'ASC';
    sortColumns?.forEach((item) => {
      if (item?.columnName === columnName) {
        sortValue = item?.sortValue === 'ASC' ? 'DESC' : 'ASC';
      }
    });
    const res = await api.get(
      `/buyers?page=${page}&limit=${rowsPerPage}&search=${globalSearchValue}&filters={${filterString}&sortByColumn=${columnName}&sortBy=${sortValue}`
    );
    if (res) {
      setIsLoading(false);
      setBuyersData(res?.data);
      setSortColumns((current) =>
        current?.map((obj) => {
          if (obj?.columnName === columnName) {
            return {
              ...obj,
              sortValue: obj?.sortValue === 'ASC' ? 'DESC' : 'ASC',
            };
          } else return obj;
        })
      );
    }
  }
  //  logic to post group API
  async function onSaveHandler(setOpen) {
    let transdata = {
      name: groupNameValue,
      description: groupDescriptionValue,
      buyerIds: selectedBuyers,
    };
    const res = await api
      .post(apiEndPoints.groupList, transdata)
      .then((res) => {})
      .catch((error) => {});
    setOpen(false);
  }
  //    logic to handle onPageChange for pagination
  const onPageChangeHandler = (event, page) => {
    event.preventDefault();
    setPage(page);
    // getBuyers(page, rowsPerPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  // logic ends onpagechange
  //  logic to handle checkbox
  function handleCheck(value) {
    if (selectedBuyers.some((obj) => obj === value.id)) {
      setSelectedBuyers(() =>
        selectedBuyers.filter((item) => item !== value.id)
      );
    } else {
      setSelectedBuyers((prev) => {
        return [...prev, value.id];
      });
    }
  }
  //
  useEffect(() => {
    if (columnSearchValues.length > 0) {
      let filters = '';
      if (!edit) filters = '{';
      // get column search filters
      columnSearchValues?.forEach((obj) => {
        filters = filters.concat(`"${obj.label}":"${obj.value}",`);
      });

      filters = filters.substring(0, filters.length - 1);
      if (!edit) filters = filters.concat('}');
      applyFilters(filters);
    }
  }, [columnSearchValues]);

  //apply filters
  function applyFilters(obj, filtersCount) {
    setSearchParams(
      createSearchParams({
        // srch: retailerSearchValue,
        // page: retailerPage,
        filters: obj ?? '',
        filtersCount: filtersCount ?? '',
      })
    );

    setFilterString(obj);
  }

  return {
    onPageChangeHandler,
    handleChangeRowsPerPage,
    page,
    getBuyers,
    rowsPerPage,
    setRowsPerPage,
    handleCheck,
    selectedBuyers,
    setSelectedBuyers,
    showEditGroupDetails,
    setShowEditGroupDetails,
    buyersData,
    globalSearchValue,
    setGlobalSearchValue,
    groupNameValue,
    setGroupNameValue,
    groupDescriptionValue,
    setGroupDescriptionValue,
    onSaveHandler,
    showApplyFiltersModal,
    setShowApplyFiltersModal,
    showZeroBuyerError,
    setShowZeroBuyerError,
    showBuyers,
    setShowBuyers,
    groups,
    setGroups,
    columnSearchValues,
    setColumnSearchValues,
    salesRep,
    setSalesRep,
    priceGroup,
    setPriceGroup,
    currency,
    setCurrency,
    filterString,
    setFilterString,
    applyFilters,
    sortBuyersColumns,
    isLoading,
    sortColumn,
    setSortColumn,
    isSelectAll,
    setIsSelectAll,
  };
}
